/**
 * @generated SignedSource<<b549fddb36ac4f1efe08a14b4fdb710e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePopupGroupInput = {
  clientMutationId?: string | null;
  popupGroupId: string;
};
export type PopupTableActions_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePopupGroupInput;
};
export type PopupTableActions_DeleteMutationVariables = PopupTableActions_DeleteMutation$variables;
export type PopupTableActions_DeleteMutation$data = {
  readonly deletePopupGroup: {
    readonly deletedPopupGroupId: string;
  } | null;
};
export type PopupTableActions_DeleteMutationResponse = PopupTableActions_DeleteMutation$data;
export type PopupTableActions_DeleteMutation = {
  variables: PopupTableActions_DeleteMutationVariables;
  response: PopupTableActions_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPopupGroupId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupGroupPayload",
        "kind": "LinkedField",
        "name": "deletePopupGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupGroupPayload",
        "kind": "LinkedField",
        "name": "deletePopupGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPopupGroupId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "521c2511fa91aa43604a1239dd244f5a",
    "id": null,
    "metadata": {},
    "name": "PopupTableActions_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PopupTableActions_DeleteMutation(\n  $input: DeletePopupGroupInput!\n) {\n  deletePopupGroup(input: $input) {\n    deletedPopupGroupId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f875d116d07bc1d8fa896ef96585732";

export default node;
